import React from "react";
import { siteInfo } from "../../data/mockData";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const FooterContact = () => (
  <>
    {/* Contact Info */}
    <div>
      <h4 className="text-[#C9A96E] font-serif text-lg font-semibold mb-6">
        Contact Us
      </h4>
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <MapPin size={18} className="text-[#C9A96E] mt-0.5 shrink-0" />
          <div className="text-white/60 text-sm">
            <div>{siteInfo.address}</div>
            <div>
              {siteInfo.city} {siteInfo.postal}
            </div>
          </div>
        </li>
        <li>
          <a
            href={`tel:${siteInfo.phone}`}
            className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors"
          >
            <Phone size={18} className="text-[#C9A96E] shrink-0" />
            {siteInfo.phone}
          </a>
        </li>
        <li>
          <a
            href={`mailto:${siteInfo.email}`}
            className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors"
          >
            <Mail size={18} className="text-[#C9A96E] shrink-0" />
            {siteInfo.email}
          </a>
        </li>
      </ul>
    </div>

    {/* Hours */}
    <div>
      <h4 className="text-[#C9A96E] font-serif text-lg font-semibold mb-6">
        Hours
      </h4>
      <ul className="space-y-3">
        {[
          { label: "Golf Course", hours: "Dawn to Dusk (Seasonal)" },
          { label: "Pub & Grill", hours: "Mon-Sun: 8:00 AM - 8:00 PM" },
          { label: "Pro Shop", hours: "Dawn to Dusk (Seasonal)" },
        ].map(({ label, hours }) => (
          <li key={label} className="flex items-start gap-3">
            <Clock size={18} className="text-[#C9A96E] mt-0.5 shrink-0" />
            <div className="text-white/60 text-sm">
              <div className="text-white font-medium">{label}</div>
              <div>{hours}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </>
);

export { FooterContact };
